import { AsyncPipe } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import { PUBLIC_ROUTES } from '../app/constants/application-routes';
import { LoadingDirective } from '../app/directives/loading.directive';
import { UserAgentService } from '../app/services/user-agent/user-agent.service';
import { VgnService } from '../app/services/vgn/vgn.service';
import { ZciCookieService } from '../app/services/zci-cookie/zci-cookie.service';
import { loadAccountUsers } from '../app/store/actions/account-permissions-page.action';
import { getLoadingStateForClientSegment } from '../app/store/selectors/account-permissions.selector';

@Component({
    selector: 'zci-root',
    templateUrl: './app-multi-account.component.html',
    standalone: true,
    imports: [RouterOutlet, AsyncPipe, LoadingDirective],
})
export class AppMultiAccountComponent implements OnInit, OnDestroy {
    private readonly store = inject(Store);
    private readonly router = inject(Router);
    private readonly cookieService = inject(ZciCookieService);
    private readonly userAgentService = inject(UserAgentService);
    private readonly vgnService = inject(VgnService);

    isMobileApp = false;

    isClientSegmentLoading$: Observable<boolean> = this.store.select(
        getLoadingStateForClientSegment,
    );

    readonly subs: Subscription = new Subscription();

    ngOnInit(): void {
        this.isMobileApp = this.userAgentService.isBeaconFound();

        if (this.isMobileApp) {
            this.vgnService.setGlobalNav();
        }

        if (
            !this.isPublicRoute(window.location.pathname) &&
            !window.location.pathname.includes('accept-access/')
        ) {
            this.store.dispatch(loadAccountUsers());
        }

        if (!this.isPublicRoute(window.location.pathname)) {
            // @ts-expect-error spoid is not defined in window
            window.spoid = this.cookieService.sPOID;
        }
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    private isPublicRoute(url: string): boolean {
        return Object.values(PUBLIC_ROUTES).some((route) => {
            if (route.includes(':token')) {
                const staticPart = route.split('/:')[0];
                return url.startsWith(`/${staticPart}`);
            }
            return url === `/${route}`;
        });
    }
}
